import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Logo } from "../components/Logo";

export const AuthShell = ({ children }) => (
  <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
    <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm fade-up">
      <Logo />
      <div className="mt-8">{children}</div>
    </div>
  </div>
);

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      setRes((await api.post("/auth/forgot-password", { email })).data);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const link = res?.reset_token ? `/reset-password?token=${res.reset_token}` : null;

  return (
    <AuthShell>
      <h2 className="text-2xl font-extrabold tracking-tight">Forgot password?</h2>
      <p className="mt-1 text-sm text-slate-500">Enter your work email and we'll generate a secure reset link.</p>
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
        <Input data-testid="forgot-email-input" type="email" required placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" />
        {error && <div data-testid="forgot-error" className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
        <Button data-testid="forgot-submit-btn" type="submit" disabled={busy} className="w-full h-11 bg-emerald-600 hover:bg-emerald-700 font-semibold">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Generate reset link"}
        </Button>
      </form>
      {res && (
        <div className="mt-5 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm" data-testid="forgot-result">
          <div className="font-semibold text-emerald-800">{res.message}</div>
          {link ? (
            <Link to={link} data-testid="reset-link" className="mt-3 inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 font-semibold text-white hover:bg-emerald-700">
              <KeyRound className="h-4 w-4" /> Reset my password
            </Link>
          ) : (
            <div className="mt-1 text-emerald-700">No active account was found for this email.</div>
          )}
        </div>
      )}
      <Link to="/login" data-testid="back-to-login-link" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" /> Back to sign in
      </Link>
    </AuthShell>
  );
}
